import React, { useEffect, useState } from "react";
import { closeicon, erroricon } from "assets/icons/index";
import { Flex, Input, notification, Spin, Typography } from "antd";
import type { GetProp } from "antd";
import type { OTPProps } from "antd/es/input/OTP";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
// import { useValidateOtpFormik } from "forms/JoinUsForms/ResetPassword/validateOtpFormik";
// import { generateOtpResetPassword } from "redux/actions/JoinUsAction/ResetPasswordActions/generateOtpResetPasswordActions";
import { useFormik } from "formik";
import * as yup from "yup";
import { generateOtpResetPasswordActions } from "redux/actions/auth/ResetPassword/generateOtpResetPasswordActions";
import { useValidateOtpFormik } from "Forms/ResetPassword/validateOtpFormik";

interface ValidateOtpResetPasswordProps {
  activePop: string;
  email: string;
  phoneNum: string;
  resetPasswordMethod: any;
  setActivePop: React.Dispatch<React.SetStateAction<string>>;
  countryCode: string;
}

interface otpType {
  otp: string;
}

const ValidateOtpResetPassword = ({
  activePop,
  setActivePop,
  resetPasswordMethod,
  email,
  phoneNum,
  countryCode,
}: ValidateOtpResetPasswordProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const formik = useValidateOtpFormik(
    setActivePop,
    resetPasswordMethod,
    phoneNum,
    email
  );

  const { validateOtpLoading } = useSelector(
    (state: RootState) => state.validateOtpResetPasswordReducer
  );

  ///////////////////////////// count down timer handle
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev: any) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  ////////////////////////// otp values output
  const onChange: GetProp<typeof Input.OTP, "onChange"> = (text) => {
    if (text.length !== 4) {
      formik.setFieldError("otp", "please fill this field");
    } else {
      formik.setFieldValue("otp", text);
    }
  };

  const sharedProps: OTPProps = {
    onChange,
  };

  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="400"
      className="fixed top-0 right-0 w-full h-screen bg-black/75 flex items-center justify-center z-10"
    >
      <div
        className={`relative lg:w-[410px] p-[30px] bg-white rounded-[15px] flex flex-col gap-[25px] text-pro_text_dark ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/*********************** Reset Password section  ************/}
        <div className="relative flex items-center justify-center">
          {/* Reset Password */}
          <div className="font-[700] text-[24px] text-second_color flex items-center justify-center">
            {t("Reset Password")}
          </div>

          {/* close button */}
          {/* <div
            // onClick={() => setShowLogin(!showLogin)}
            className="absolute top-0 right-0 cursor-pointer"
          >
            <img src={closeicon} alt="logo" />
          </div> */}
          <div></div>
        </div>

        {/*********************** instructions ************/}
        {resetPasswordMethod === 1 ? (
          <div className="font-[600] text-[14px] text-second_color flex items-center justify-center">
            {t("Please enter the code we sent to your phone")}
          </div>
        ) : (
          <div className="font-[600] text-[14px] text-second_color flex items-center justify-center">
            {t("Please enter the code we sent to your email")}
          </div>
        )}

        {/*********************** Phone number section  ************/}
        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col gap-[20px] text-white"
        >
          {/* otp code values  */}
          <Spin spinning={validateOtpLoading}>
            <div className="flex items-center justify-center">
              <Flex gap="middle" align="flex-start" vertical>
                <Input.OTP length={4} {...sharedProps} dir="ltr" />
              </Flex>
            </div>
          </Spin>

          {/* errors section  */}
          <div className="w-full flex items-center justify-center">
            {formik.errors.otp && (
              <p className="text-red-700 font-Avenir_demi text-[14px] flex items-center gap-1 animate-pulse">
                <img className="w-[22px]" src={erroricon} alt="" />{" "}
                {formik.errors.otp}
              </p>
            )}
          </div>

          {/* resend the verification code */}
          <div className="font-[500] text-[14px] text-second_color text-center border-t-[1px] pt-[10px]">
            {t("You can resend the verification code after")}{" "}
            <span className="font-Avenir_bold ml-[10px]">
              {formatTime(timer)}
            </span>
          </div>

          {/* Resend the code */}
          {timer === 0 && (
            <Spin spinning={validateOtpLoading}>
              <div
                onClick={() =>
                  dispatch(
                    generateOtpResetPasswordActions(
                      resetPasswordMethod === 1
                        ? {
                            screen: "app_password_reset", //static value
                            lang: `${i18n.language}`, // app language ar or en
                            country_code: countryCode,
                            phone_number: phoneNum,
                            device: "web", // static
                          }
                        : {
                            screen: "app_password_reset", //static value
                            lang: `${i18n.language}`, // app language ar or en
                            email: email, // user registered email
                            device: "web", // static
                          },
                      () => {
                        setTimer(60);
                      }
                    )
                  )
                }
                className="font-[600] text-[14px] text-first_color flex items-center justify-center underline cursor-pointer"
              >
                {t("Resend the code")}
              </div>
            </Spin>
          )}

          {/* Send Code button  */}
          <Spin spinning={validateOtpLoading}>
            <button
              type="submit"
              className="w-full h-[40px] bg-[#DCDEE3] text-second_color text-[14px] font-[600] rounded-[15px] hover:text-white hover:bg-first_color duration-300"
            >
              {t("Verify")}
            </button>
          </Spin>
        </form>
      </div>
    </section>
  );
};

export default ValidateOtpResetPassword;
